// Module
var code = "<div class=\"spinner-container\" ng-if=\"active\"> <div class=\"spinner-subcontainer\"> <div ng-transclude> <div class=\"spinner\"> <div class=\"rect1\"></div> <div class=\"rect2\"></div> <div class=\"rect3\"></div> <div class=\"rect4\"></div> <div class=\"rect5\"></div> </div> </div> </div> </div>";
// Exports
module.exports = code;